var keyMirror = require('keymirror');

module.exports = keyMirror({
    RESPONSE_RECIEVED: null,
    GET_PORTFOLIO_USERS: null,
    GET_ALL_USER_ROLE: null,
    INVITE_PORTFOLIO_USER: null,
    REMOVE_PORTFOLIO_USER: null,
    GET_PORTFOLIO_USER_DETAILS: null
});